module.exports = __webpack_public_path__ + "static/media/tag5.ba65b587.svg";